import React from 'react';
import { CircleCheckBigIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/links';
type CTAButtonProps = {
  label: string;
  note?: string;
  id?: string;
  tone?: 'light' | 'dark';
};
export function CTAButton({
  label,
  note,
  id,
  tone = 'light'
}: CTAButtonProps) {
  return <div id={id} className="flex w-full flex-col items-center text-center" data-id="element-28" data-mp="2fz20qldwwuuz">
      <a href={CHECKOUT_URL} className="flex w-full max-w-xl items-center justify-center gap-3 rounded-2xl bg-cta px-5 py-4 text-[15px] font-extrabold uppercase leading-snug tracking-wide text-white shadow-[0_14px_30px_-12px_rgba(21,133,74,0.75)] transition-[transform,background-color] duration-150 ease-out hover:bg-ctaDark active:scale-[0.98] focus:outline-none focus-visible:ring-4 focus-visible:ring-cta/40 sm:py-5 sm:text-lg" data-id="element-29" data-mp="2tzcubw6lwnju">
        <CircleCheckBigIcon className="h-6 w-6 shrink-0" aria-hidden="true" data-id="element-30" data-mp="3cqdq6bcfk2z6" />
        <span data-id="element-31" data-mp="38pab3r27iaz0">{label}</span>
      </a>
      {note && <p className={`mt-3 max-w-md text-sm leading-relaxed ${tone === 'dark' ? 'text-cream/80' : 'text-muted'}`} data-id="element-32" data-mp="38mfr20n3us64">
          {note}
        </p>}
    </div>;
}